import { createContext } from 'react'
import { io, Socket } from 'socket.io-client'
const socket = io(process.env.REACT_APP_PUBLIC_API as string, { withCredentials: true, transports: ['websocket'] })
const SocketContext = createContext<Socket>(socket)

export { socket, SocketContext }
